<template>
  <p class="truncate text-sm font-semibold">{{ sender }} mentioned you</p>
  <p v-if="scenarioName" class="truncate text-sm text-gray-600">{{ scenarioName }}</p>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  notification: {
    type: Object,
    required: true
  }
})

const sender = computed(() => props.notification.runArgs?.fromEmail || 'Someone')
const scenarioName = computed(() => props.notification.runArgs?.scenarioName || '')
</script>
